export const defaultLocale = 'sk-SK';

// https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
const numberWithThousandsDelimiter = (number, delimiter) =>
  number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);

const numberWithDecimalDelimiter = (number, delimiter) =>
  number.toString().replace(/\./g, delimiter);

// use &minus; for sign and &thinsp; for delimiter
const numberRules = {
  'sk-SK': (number, decimals) => {
    const sign = number < 0 ? '\u2212' : '';
    const newNumber = Math.abs(number).toFixed(decimals);
    const formattedNumber = numberWithThousandsDelimiter(
      numberWithDecimalDelimiter(newNumber, ','),
      '\u202F'
    );
    return `${sign}${formattedNumber}`;
  },
  'en-GB': (number, decimals) => {
    const sign = number < 0 ? '\u2212' : '';
    const newNumber = Math.abs(number).toFixed(decimals);
    const formattedNumber = numberWithThousandsDelimiter(newNumber, ',');
    return `${sign}${formattedNumber}`;
  },
};

export const formatNumber = (locale, number, decimals = 0) =>
  (numberRules[locale] || numberRules[defaultLocale])(number, decimals);

// use &thinsp; for delimiter
export const formatCurrency = (locale, number, currency, decimals = 2) =>
  `${formatNumber(locale, number, decimals)}\u2009${currency}`;




// WEBPACK FOOTER //
// ./app/Assets/js/utils/i18n.js